import {GatewayRequest, GwRequestId} from '../../state/types/pending-requests.js';
import {PeerType} from '../../state/types/factory.js';
import {Activity, ActivityPeer} from '../../state/types/activity.js';

export function activity(requestId: GwRequestId, activityPeer: ActivityPeer, activity: Activity, isActivityOwner: boolean): GatewayRequest {
    const request: GatewayRequest = {
        type: 'activity',
        id: requestId,
        peer_type: activityPeer.type,
        activity: {id: activity.id, 'owner?': isActivityOwner}
    };
    if (activityPeer.name) {
        request.peer_name = activityPeer.name;
    }
    return request;
}

export function reload(requestId: GwRequestId, activityPeer: ActivityPeer, activity: Activity): GatewayRequest {
    const request: GatewayRequest = {
        type: 'activity',
        id: requestId,
        peer_type: activityPeer.type,
        activity: {id: activity.id, 'owner?': activity.owner === activityPeer['id']},
        reload: true
    };
    if (activityPeer.name) {
        request.peer_name = activityPeer.name;
    }
    return request;
}

export function factory(requestId: GwRequestId, peerType: PeerType, peerName, clientRequest): GatewayRequest {
    const request: GatewayRequest = {
        type: 'create-peer',
        id: requestId,
        peer_type: peerType,
        clientRequest
    };
    if (peerName) {
        request.peer_name = peerName;
    }
    return request;
}
